import { render, staticRenderFns } from "./CouponSendConfig.vue?vue&type=template&id=58baaf2a&scoped=true"
import script from "./CouponSendConfig.vue?vue&type=script&lang=js"
export * from "./CouponSendConfig.vue?vue&type=script&lang=js"
import style0 from "./CouponSendConfig.vue?vue&type=style&index=0&id=58baaf2a&scoped=true&lang=scss"
import style1 from "./CouponSendConfig.vue?vue&type=style&index=1&id=58baaf2a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58baaf2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58baaf2a')) {
      api.createRecord('58baaf2a', component.options)
    } else {
      api.reload('58baaf2a', component.options)
    }
    module.hot.accept("./CouponSendConfig.vue?vue&type=template&id=58baaf2a&scoped=true", function () {
      api.rerender('58baaf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/CouponSend/CouponSendConfig.vue"
export default component.exports